import { create } from 'zustand';

interface UpdateStore {
  modalOpen: boolean;
  deleteEndpoint?: string;
  payload?: any;
  editEndpoint?: string;
  callback?: () => void;
  isEdit?: boolean;
  isDelete?: boolean;
  updateFields?: [];
  sourceAction?: string;
}

let settings: UpdateStore = {
  modalOpen: false,
  deleteEndpoint: '',
  editEndpoint: '',
  payload: {},
  callback: () => {},
  isEdit: false,
  isDelete: false,
  updateFields: [],
  sourceAction: ''
};

export interface UpdateState {
  actions: {
    setModal: (settings: UpdateStore) => void;
    clearModal: () => void;
  };
  settings: UpdateStore;
}

export const useUpdateModalStore = create<UpdateState>((set) => ({
  settings,
  actions: {
    setModal: (settings: UpdateStore) => {
      // @ts-ignore
      set((state) => {
        return {
          settings: {
            ...state.settings,
            ...settings,
            // isEdit: settings.isEdit || false,
            // isDelete: settings.isDelete || false

          }
        }
      });
    },
    clearModal: () => {
      set((state) => ({
        settings: {
          ...state.settings,
          modalOpen: false,
          sourceAction: null,
          payload: {}
        }
      }));
    }
  }
}));
